import $ from 'jquery'
import Sticky from 'sticky-js/src/sticky';
//import ScrollReveal from 'scrollreveal';

export default {
    init() {
        //ScrollReveal().reveal('section .container', { delay: 250, easing: 'ease-in' });
        //const images = document.querySelectorAll("img");
    },
    finalize() {

        if (window.location.hash) {
            const hash = window.location.hash;
            const section = document.querySelector(hash)
            if (section) {
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: section.offsetTop
                });
            }

        }

        const loadedForms = []
        function displayFormModal(id, formId, formReady, formSubmit) {
            var target = ""
            if(id == '#form-demo'){
                target = '.embedform-demo'
            }
            if(id == '#form-pricing-leaks'){
                target = '.embedform-pricing'
            }
            if(id == '#form-pricing-monitor'){
                target = '.embedform-monitor'
            }
            if(id == '#form-api'){
                target = '.embedform-api'
            }
            if(id == '#contact-form'){
                target = '.embedform-contact'
            }
            if (loadedForms.indexOf(formId)) {
                hbspt.forms.create({
                    portalId: '4144962',
                    target: target,
                    formId,
                    onFormReady($form) {
                        formReady($form)
                    },
                    onFormSubmit($form) {           
                        formSubmit($form)
                    }
                });
                loadedForms.push(formId)
            }

            $('body').css({ overflow: 'hidden' })
            $(id).toggleClass('hidden')
            $(`${id} .icon-close`).on('click', () => {
                $(id).toggleClass('hidden')
                $(`${id} .icon-close`).off('click')
                $('body').css({ overflow: 'auto' })
            })

            
        }
        $('.has-children').on('mouseover', () => {
            $('.submenu').removeClass('hidden');
        })
        $('.has-children').on('mouseleave', () => {
            $('.submenu').addClass('hidden');
        })
        $('.form-demo, .request-a-demo').on('click', (event) => {
            event.preventDefault();
            displayFormModal('#form-demo', formDemoId, () => {
                window.dataLayer.push({
                    'event': 'form-open',
                    'formType': 'demo'
                });
            }, ($form) => {
                window.dataLayer.push({
                    'event': 'demo-form-success',
                    'formIndustry': $form[0].industry.value
                });
            })
        });

        $('.form-contact').on('click', (event) => {
            event.preventDefault();
            displayFormModal('#contact-form', formContactId, () => {
                window.dataLayer.push({
                    'event': 'form-open',
                    'formType': 'contact'
                });
            }, ($form) => {
                window.dataLayer.push({
                    'event': 'contact-form-success',
                    'formIndustry': $form[0].industry.value
                })
            })
        });

        $('.form-api').on('click', (event) => {
            event.preventDefault();
            displayFormModal('#form-api', formApiId, () => {
                window.dataLayer.push({
                    'event': 'form-open',
                    'formType': 'api'
                });
            }, ($form) => {
                window.dataLayer.push({
                    'event': 'api-form-success',
                    'formIndustry': $form[0].industry.value
                });
            })
        });

        $('.form-pricing-monitor').on('click', (event) => {
            event.preventDefault();
            displayFormModal('#form-pricing-monitor', formPricingMonitorId, ($form) => {
                window.dataLayer.push({
                    'event': 'form-open',
                    'formType': 'pricing'
                });
            }, ($form) => {
                const siteTypes = []
                $form[0].monitored_sites.forEach((e) => {
                    if (e.checked) {
                        siteTypes.push(e.value)
                    }
                })


                window.dataLayer.push({
                    'event': 'pricing-form-success',
                    'formIndustry': $form[0].industry.value,
                    'filesnumber': $form[0].number_of_assets.value,
                    'contentType': $form[0].type_of_assets.value,
                    'siteTypes': siteTypes.join(','),
                })
            })
        });

        $('.form-pricing-leaks').on('click', (event) => {
            event.preventDefault();
            displayFormModal('#form-pricing-leaks', formPricingLeaksId, ($form) => {
                window.dataLayer.push({
                    'event': 'form-open',
                    'formType': 'pricing'
                });
            }, ($form) => {
                const siteTypes = []
                $form[0].monitored_sites.forEach((e) => {
                    if (e.checked) {
                        siteTypes.push(e.value)
                    }
                })
                window.dataLayer.push({
                    'event': 'pricing-form-success',
                    'formIndustry': $form[0].industry.value,
                    'filesnumber': $form[0].number_of_assets.value,
                    'contentType': $form[0].type_of_assets.value,
                    'siteTypes': siteTypes.join(',')
                })
            })
        });

        $('.menu-open').on('click', () => {
            $('nav.responsive').toggleClass('opened')
        })

        const stickyElement = document.querySelector('.sticky-element')
        if (stickyElement) {
            new Sticky('.sticky-element')
            const elements = document.querySelectorAll('[data-id]')
            const positions = Array.from(elements).map(e => ({ id: e.dataset.id, position: e.offsetTop - 65 }))
            const colors = {
                'monitor': 'text-blue-lighter',
                'leaks': 'text-orange',
            }

            $(window).scroll(() => {
                const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
                let elements = positions.filter(e => scrollPos > e.position)
                const current = elements[elements.length - 1]
                if (current) {
                    Object.values(colors).forEach((e) => {
                        $('.color-dynamic').removeClass(e);
                        $('.color-dynamic').addClass('text-grey-darker')
                    })
                    $(`#${current.id}`)
                        .removeClass('text-grey-darker')
                        .addClass(colors[current.id])
                }
            });
        }

        $('#cookies-preferences').on('click', (e) => {
            e.preventDefault();
            if (window.Optanon) {
                window.Optanon.ToggleInfoDisplay();
            }
        })

        $('.question').click(function() {
            console.log($(this).next('.answer')
.is(':visible'))
            if ($(this).next('.answer')
.is(':visible')) {
                $('.answer').slideUp();
                $('.question svg').addClass('-rotate-90');
            } else {
                $('.answer').hide()
                $('.question svg').addClass('-rotate-90');
                $(this).next('.answer')
.slideDown();
                $(this).find('svg')
.removeClass('-rotate-90');
            }
        })
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js